import { render, staticRenderFns } from "./item.vue?vue&type=template&id=25d95c20&scoped=true&"
import script from "./item.vue?vue&type=script&lang=ts&"
export * from "./item.vue?vue&type=script&lang=ts&"
import style0 from "./item.vue?vue&type=style&index=0&id=25d95c20&prod&lang=less&scoped=true&"
import style1 from "./item.vue?vue&type=style&index=1&id=25d95c20&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d95c20",
  null
  
)

export default component.exports